import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {DateRangeReportCriteriaComponent} from "./common-report-criteria/date-range-report-criteria/date-range-report-criteria.component";
import {DetailReportCriteriaComponent} from "./common-report-criteria/detail-report-criteria/detail-report-criteria.component";
import {EntitySubGroupByReportCriteriaComponent} from "./common-report-criteria/entity-sub-group-by-report-criteria/entity-sub-group-by-report-criteria.component";
import {TaxInclusiveReportCriteriaComponent} from "./common-report-criteria/tax-inclusive-report-criteria/tax-inclusive-report-criteria.component";
import {EntityGroupByReportCriteriaComponent} from "./common-report-criteria/entity-group-by-report-criteria/entity-group-by-report-criteria.component";
import {SingleDateReportCriteriaComponent} from "./common-report-criteria/single-date-report-criteria/single-date-report-criteria.component";
import {MyreportUnscheduleSearchActionComponent} from "./myreport/controls/myreport-unschedule-search-action.component";
import {MyreportRunNowSearchActionComponent} from "./myreport/controls/myreport-run-now-search-action.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule
    ],
    declarations: [
        DateRangeReportCriteriaComponent,
        SingleDateReportCriteriaComponent,
        DetailReportCriteriaComponent,
        EntitySubGroupByReportCriteriaComponent,
        TaxInclusiveReportCriteriaComponent,
        EntityGroupByReportCriteriaComponent,
        MyreportUnscheduleSearchActionComponent,
        MyreportRunNowSearchActionComponent
    ],
    exports: [
        DateRangeReportCriteriaComponent,
        SingleDateReportCriteriaComponent,
        DetailReportCriteriaComponent,
        EntitySubGroupByReportCriteriaComponent,
        TaxInclusiveReportCriteriaComponent,
        EntityGroupByReportCriteriaComponent,
        MyreportUnscheduleSearchActionComponent,
        MyreportRunNowSearchActionComponent
    ]
})
export class ReportsSharedModule {
}
